<template>
    <div :class="colClass">
        <button
            :type="loading ? 'button' : type"
            :class="computedBtnClass"
            :disabled="loading || disabled"
        >
            <template v-if="loading">
        <span class="flex items-center gap-2 justify-center">
          <!-- Tailwind spinning loader like Blade -->
          <svg
              v-if="!bootstrap"
              class="inline animate-spin h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
            <!-- Bootstrap spinner if bootstrap=true -->
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

          {{ loadingText }}
        </span>
            </template>

            <template v-else>
                <slot>{{ title }}</slot>
            </template>
        </button>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useLoadingStore } from "@/stores/loadingStore.js";

const props = defineProps({
    title: { type: String, default: "Submit" },
    type: { type: String, default: "submit" },
    btnClass: { type: String, default: "" },
    loaderClass: { type: String, default: "" },
    loadingText: { type: String, default: "Loading..." },
    bootstrap: { type: Boolean, default: false },
    col: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
});

const loadingStore = useLoadingStore();
const { isLoading: loading } = storeToRefs(loadingStore);

const colClass = computed(() => props.col || "inline-block");

const computedBtnClass = computed(() => {
    return loading.value ? props.loaderClass || defaultBtnClass.value : props.btnClass || defaultBtnClass.value;
});

const defaultBtnClass = computed(() => {
    if (props.bootstrap) return "btn btn-primary mt-4";
    return `bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-8 rounded-lg mt-4 transition duration-150 ease-in-out ${props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`;
});
</script>
